import { toast } from 'react-toastify';
type toastType = {
  success: boolean | string;
  message: string;
};
const ReactToastify = ({ success, message }: toastType) => {
  if (success === true || success === 'true') {
    return toast(message, {
      type: 'success',
      theme: 'light',
      toastId: 'success',
    });
  } else if (success === false || success === 'false') {
    return toast(message, {
      type: 'error',
      theme: 'light',
      toastId: 'error',
    });
  } else {
    return toast(message, {
      theme: 'light',
      type: 'info',
      toastId: 'info',
    });
  }
};

export default ReactToastify;
